import React, { Component } from "react";
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import { CssBaseline, CircularProgress, Container, Grid, Button, Tooltip } from "@material-ui/core";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import LaunchIcon from '@material-ui/icons/Launch';
import { withStyles } from "@material-ui/core/styles";
import { Styles } from "../../styles/material-styles";
import { Overlay } from "../../styles/global";
import CustomizedSnackbars from "../../components/material-snackbars";
import HeaderMenu from "../../components/header-menu";
import Footer from '../../components/footer';
import { injectIntl } from 'react-intl';
import ProvisioningDetailPanel from '../../components/provisioning-detail-panel';
import * as componentActions from '../../redux/actions/admin-billing';

// Status do contrato considerados "trial": 5 = Em Trial, 7 = Expirado
const TRIAL_CONTRACT_STATUS_IDS = [5, 7];

class AdminProvisioningDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            openNotification: false,
            notificationVariant: "error",
            notificationMessage: "",
            contractDetail: null,
        };
        this.closeNotification = this.closeNotification.bind(this);
    }

    handleGoToContract = () => {
        const { contractDetail } = this.state;
        if (!contractDetail) return;
        const lang = this.props.match.params.lang;
        const isTrial = TRIAL_CONTRACT_STATUS_IDS.includes(contractDetail.contractstatusid);
        const payload = {
            hirerid: contractDetail.hirerid,
            contractid: contractDetail.contractid,
        };
        // Trial → currentTrial, assinatura → currentHirer (chaves consumidas pelas
        // respectivas páginas de detalhe em componentDidMount).
        if (isTrial) {
            this.props.addCurrentTrial(payload);
            this.props.history.push(`/${lang}/admin-trial-detail`);
        } else {
            this.props.addCurrentHirer(payload);
            this.props.history.push(`/${lang}/admin-subscription-detail`);
        }
    }

    componentDidMount() {
        const { currentProvisioning } = this.props;
        if (!currentProvisioning || !currentProvisioning.id) {
            this.props.history.push(`/${this.props.match.params.lang}/admin-provisioning`);
        }
    }

    closeNotification() {
        this.setState({ openNotification: false });
    }

    render() {
        const { classes, headerMenu, currentProvisioning } = this.props;
        const intl = this.props.intl;

        return (
            <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
                <HeaderMenu />
                <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
                    <div className={classes.drawerHeader} />
                    <Container component='main' maxWidth='lg'>
                        <CssBaseline />

                        {currentProvisioning && currentProvisioning.id && (
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Button startIcon={<ArrowBackIcon />}
                                        onClick={() => this.props.history.push(`/${this.props.match.params.lang}/admin-provisioning`)}
                                        style={{ marginBottom: 12, textTransform: 'none' }}>
                                        {intl.formatMessage({ id: "back" })}
                                    </Button>

                                    <ProvisioningDetailPanel
                                        provisioningId={currentProvisioning.id}
                                        defaultEmail={this.props.userSession?.user?.email || ''}
                                        enablePolling={true}
                                        onLoadingChange={(loading) => this.setState({ loading })}
                                        onDetailLoaded={(detail) => this.setState({ contractDetail: detail })}
                                        extraActions={
                                            this.state.contractDetail ? (
                                                <Tooltip title="Ir para contrato">
                                                    <Button
                                                        size="small"
                                                        variant="outlined"
                                                        color="primary"
                                                        startIcon={<LaunchIcon />}
                                                        onClick={this.handleGoToContract}
                                                        style={{ textTransform: 'none', marginRight: 8 }}
                                                    >
                                                        Ir para contrato
                                                    </Button>
                                                </Tooltip>
                                            ) : null
                                        }
                                        onNotify={(variant, msg) => this.setState({ openNotification: true, notificationVariant: variant, notificationMessage: msg })}
                                    />
                                </Grid>
                            </Grid>
                        )}

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color="secondary" />
                            </Overlay>
                        )}
                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                    </Container>
                </main>
                <Footer />
            </div>
        );
    }
}

AdminProvisioningDetail.propTypes = {
    classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    headerMenu: state.headerMenu,
    userSession: state.userSession,
    currentProvisioning: state.adminBilling.currentProvisioning,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(componentActions, dispatch);

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(AdminProvisioningDetail)));
